import moment from 'moment';
import React, { Component, Fragment } from 'react';
import ReactTable from 'react-table';
import DistrictSummary from './districtSummary'

class ApplicationSelection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showAddApplicationTab: false,
            isDisSummaryDialogOpen: false

        }
    }

    handleDeleteSelectedHouseholdApps = (row) => {
        this.props.deleteFromSelectedList(row)

    }
    isRowSelected = (row) => {
        const { householdApplications, selectedRows } = this.props;
        return [...householdApplications, ...selectedRows].some(
            (selectedRow) => selectedRow.applicationId === row.applicationId
        );
    };
    handleRowSelection = (row) => {
        const isSelected = this.isRowSelected(row);
        if (isSelected) {
            this.props.unSelectFromSelectedList(row);
        } else {
            this.props.onSelectApplication(row);
        }
    };
    getAllAppsCols = () => {
        return [
            {
                accessor: "applicationId",
                Header: "Application Id",
                style: {
                    "textAlign": "center"
                }
            },
            {
                accessor: "appliedDate",
                Header: "Applied Date",
                style: {
                    "textAlign": "center"
                }
            },
            {
                accessor: "schoolName",
                Header: "School",
                style: {
                    "textAlign": "center"
                }
            },
            {
                accessor: "studentName",
                Header: "Student Name",
                style: {
                    "textAlign": "center"
                }
            },
            {
                accessor: "currentEligibility",
                Header: "Current Eligibility",
                style: {
                    "textAlign": "center"
                }
            },
            {
                accessor: "applicationCategory",
                Header: "Category",
                style: {
                    "textAlign": "center"
                }
            },
            {
                accessor: "errorProne",
                Header: "Errorprone",
                style: {
                    "textAlign": "center"
                }
            }, {
                id: 'action',
                Header: 'Action',
                accessor: 'action',
                Cell: ({ row }) => {
                    const { _original } = row;
                    return <input
                        id={_original.applicationId}
                        type="checkbox"
                        checked={this.isRowSelected(_original)}
                        onChange={() => this.handleRowSelection(_original)}
                    />
                },
                style: { textAlign: 'center' }
            }
        ];
    }

    getMainTableCols = () => {
        return [
            {
                accessor: "applicationId",
                Header: "Application Id",
                style: {
                    "textAlign": "center"
                }
            },
            {
                accessor: "appliedDate",
                Header: "Applied Date",
                style: {
                    "textAlign": "center"
                }
            },
            {
                accessor: "schoolName",
                Header: "School",
                style: {
                    "textAlign": "center"
                }
            },
            {
                accessor: "studentName",
                Header: "Student Name",
                style: {
                    "textAlign": "center"
                }
            },
            {
                accessor: "currentEligibility",
                Header: "Current Eligibility",
                style: {
                    "textAlign": "center"
                }
            },
            {
                accessor: "applicationCategory",
                Header: "Category",
                style: {
                    "textAlign": "center"
                }
            },
            {
                accessor: "errorProne",
                Header: "Errorprone",
                style: {
                    "textAlign": "center"
                }
            }, {
                accessor: 'action',
                Header: 'Action',
                width: 100,
                Cell: ({ row }) => {
                    const { _original } = row;
                    return <div style={{ textAlign: 'center', whiteSpace: 'normal' }}>
                        <i
                            className="fa fa-trash"
                            style={{ color: 'black', cursor: 'pointer' }}
                            onClick={() => this.handleDeleteSelectedHouseholdApps(_original)}
                        />
                    </div>
                }
            }
        ];
    }
    renderApplicationCountDetails = () => {
        const { applications, householdApplications } = this.props;
        return <div className='row'>
            <div className='col-md-12'>
                <div className="pl-5" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-evenly' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '50%' }}>
                        <label>
                            <span className="color-3" style={{ fontSize: '13px', paddingLeft: '20px' }}>Total Applications:</span>
                            <span className="color-4"> {(applications || []).length}</span>
                        </label>
                        <label>
                            <span className="color-3" style={{ fontSize: '13px' }}>Selected Applications:</span>
                            <span className="color-4"> {(householdApplications || []).length}</span>
                        </label>
                        <label>
                            <span className="color-3" style={{ fontSize: '13px' }}>Selection Percentage:</span>
                            <span className="color-4"> {(applications || []).length === 0 ? 0 : (((householdApplications || []).length / (applications || []).length) * 100).toFixed(1)} %</span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    }
    openDisSummaryDialog = () => {
        this.setState({
            isDisSummaryDialogOpen: true,
        });
    };

    closeDisSummaryDialog = () => {
        this.setState({
            isDisSummaryDialogOpen: false,
        });
    };
    render() {
        const { showAddApplicationTab, isDisSummaryDialogOpen } = this.state;
        const { applications, householdApplications, onCancelSelectedApps, onAddSelectedApplications } = this.props;
        return (
            <Fragment>
                <div className="panel">
                    <div >
                        <div className="row">
                            <div className='col-md-4 sectionTitle'>
                                <h2 style={{ marginTop: '0px' }}>Application Selection</h2>
                            </div>
                            <div className='col-md-8 text-right'>
                                {
                                    !showAddApplicationTab ? <Fragment>
                                        <button className='btn btn-sm btn-primary' style={{ margin: '0px', marginRight: '8px' }} onClick={() => {
                                            this.setState({ showAddApplicationTab: true })

                                        }}>Add Applications</button>
                                        <button className='btn btn-sm btn-primary' style={{ margin: '0px', marginLeft: '8px' }} onClick={() => {
                                            this.openDisSummaryDialog();
                                        }}>District Summary</button>

                                    </Fragment> : null
                                }
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12'>
                                {
                                    !showAddApplicationTab && this.renderApplicationCountDetails()
                                }
                            </div>
                        </div>
                        {isDisSummaryDialogOpen ?
                            <DistrictSummary applicationsList={applications} householdAppsList={householdApplications} onClose={this.closeDisSummaryDialog} /> : null
                        }
                        {
                            showAddApplicationTab ? <div className='row'>
                                <div className='col-md-12' style={{ marginBottom: '5px' }}>
                                    <ReactTable className="-striped -highlight"
                                        ref={r => (this.allAppsTable = r)}
                                        data={applications}
                                        columns={this.getAllAppsCols()}
                                        defaultPageSize={10}
                                        getTrProps={(rowInfo) => ({
                                            onClick: () => {
                                                //this.handleRowSelection(rowInfo);
                                            },
                                        })}
                                    />

                                </div>
                                <div className='col-md-12 text-right'>
                                    <button className='btn btn-sm btn-primary' style={{ margin: '0px', marginRight: '10px' }} onClick={() => {
                                        onCancelSelectedApps();
                                        this.setState({ showAddApplicationTab: false });


                                    }}>Cancel</button>
                                    <button className='btn btn-sm btn-primary' style={{ margin: '0px' }} onClick={() => {
                                        onAddSelectedApplications();
                                        this.setState({ showAddApplicationTab: false });
                                    }}>Add Selected List</button>

                                </div>
                            </div> : <div className='row'>
                                <div className='col-md-12'>
                                    <ReactTable className="-striped -highlight"
                                        ref={r => (this.checkboxTable = r)}
                                        data={householdApplications}
                                        columns={this.getMainTableCols()}
                                        defaultPageSize={10}
                                        getTrProps={(rowInfo) => ({
                                            onClick: () => {
                                                //this.handleRowSelection(rowInfo);
                                            },
                                        })}
                                    />
                                </div>

                            </div>
                        }
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default ApplicationSelection;


// WEBPACK FOOTER //
// ./src/components/District/applicationVerification/applicationSelection.js